export default {
    methods: {
        getErrorMsg(name) {
            let error = this.errors.collect(name)
            
            if(error.length)
                error[0] = error[0].replace(/^The (.*?) /, 'This ')
            
            return error[0]
        },
        
        getAnyError(names) {
            let name = this.anyError(names)
            return name === false ?'' :this.getErrorMsg(name)
        },
        
        anyError(names) {
            let result = false
            
            this.peer.$.each(names.split('|'), (k, v) => {
                if(this.errors.has(v)) {
                    result = v
                    return false
                }
            })
            
            return result
        },
        
        loadErrors(obj, alias) {
            alias = alias || {}
            
            this.peer._.forIn(obj, (v, k) => {
                k = k.replace(/\./g, '_')
                
                if(alias[k]) {
                    if(typeof alias[k] == 'function')
                        v = alias[k](v)
                    else
                        k = alias[k]
                }
                
                this.errors.add({
                    field: k,
                    msg: v
                })
            })
        }
    }
}
